import { render, staticRenderFns } from "./AlertScheduling.vue?vue&type=template&id=6b229d42"
import script from "./AlertScheduling.vue?vue&type=script&lang=js"
export * from "./AlertScheduling.vue?vue&type=script&lang=js"
import style0 from "./AlertScheduling.vue?vue&type=style&index=0&id=6b229d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports